import React from "react"
import PropTypes from "prop-types"
// Components
import GlassesIcon from "../../components/GlassesIcon"
// Styles
import { Wrapper } from "./MovingIcon.styles"
import { useTheme } from "styled-components"


const MovingIcon = ({ startTop, startLeft, endTop, endLeft }) => {
    const theme = useTheme()
    return (
        <Wrapper
            startTop={startTop}
            startLeft={startLeft}
            endTop={endTop}
            endLeft={endLeft}
        >
            <GlassesIcon color={theme.primary} />
        </Wrapper>
    )
}

MovingIcon.propTypes = {
    startTop: PropTypes.number,
    startLeft: PropTypes.number,
    endTop: PropTypes.number,
    endLeft: PropTypes.number
}
export default MovingIcon
